import {
    LOAD_STUDY_TEAM,
} from 'pages/delegationOfAuthority/v2/actions/studyTeam';
import {composeReducers} from 'complionUtil';

export function loadStudyTeam(state, action) {
    if (!action || action.type !== LOAD_STUDY_TEAM) {
        return state;
    }
    return {
        ...state,
        studyTeam: action.payload,
    };
}

export default composeReducers(
    loadStudyTeam
);